<template>
  <div
    :class="{
      'contact-detail-fi': true,
      'contact-detail-fi--link': href,
    }"
  >
    <icon-fi
      v-if="icon"
      class="contact-detail-fi__icon"
      :icon="icon"
    />

    <component
      :is="href ? 'a' : 'span'"
      :class="`contact-detail-fi__text fi-text-size-df-${dfTextSize}`"
      :href="href"
      :target="target"
      :rel="target && target === '_blank' ? 'noopener noreferrer' : null"
    >
      {{ detail }}
    </component>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';

defineOptions({ name: 'ContactDetails' });

withDefaults(
  defineProps<{
    icon?: string | null;
    target?: string | null;
    href?: string | null;
    detail: string;
    dfTextSize?: number;
  }>(),
  {
    icon: null,
    target: null,
    href: null,
    dfTextSize: 16,
  },
);
</script>

<style scoped src="./contact-detail-fi" />
